export default "__VITE_ASSET__DDdXIBgH__"